import { getRequest, postRequest, putRequest } from '@bo-apis/axios';

const createBookmarkMenu = (payload) => {
  return postRequest({
    url: '/api/v1/system/menu/bookmark',
    data: { ...payload },
  });
};

const getBookmarkMenu = (skip = {}) => {
  return getRequest(
    {
      url: '/api/v1/system/menu/bookmark',
    },
    skip
  );
};

const getLnbMenuList = (skip = {}) => {
  return getRequest(
    {
      url: '/api/v1/system/menu/get-lnb-menu-list',
    },
    skip
  );
};

const getMenuList = ({ ...form }) => {
  return postRequest({
    url: '/api/v1/system/menu/get-menu-list',
    data: { ...form },
  });
};

const saveMenuGridData = (gridData) =>
  postRequest({
    url: '/api/v1/system/menu/save-menu-list',
    data: { ...gridData },
  });

const getMenuApiMappingList = (menuNumber) =>
  getRequest({
    url: `/api/v1/system/menu/${menuNumber}/get-menu-api-list`,
  });

const saveMenuApiMappingGridData = (gridData) =>
  postRequest({
    url: `/api/v1/system/menu/save-menu-api-list`,
    data: { ...gridData },
  });

const getMenuPageList = () => {
  return getRequest({
    url: '/api/v1/system/menu/get-menu-page-list',
  });
};

const getCoMenuInfoList = (siteNumber) =>
  getRequest({
    url: `/api/v1/system/menu/${siteNumber}/get-co-menu-list`,
  });

const saveCoMenuList = (siteNumber, changedData) =>
  putRequest({
    url: `/api/v1/system/menu/save-co-menu-list`,
    data: {
      siteNumber,
      changedData,
    },
  });

const getLnbCoMenuList = (skip = {}) => {
  return getRequest(
    {
      url: '/api/v1/system/menu/get-lnb-co-menu-list',
    },
    skip
  );
};

export default {
  createBookmarkMenu,
  getBookmarkMenu,
  getLnbMenuList,
  saveMenuGridData,
  getMenuList,
  getMenuApiMappingList,
  saveMenuApiMappingGridData,
  getMenuPageList,
  getCoMenuInfoList,
  saveCoMenuList,
  getLnbCoMenuList,
};
